import React, { useEffect } from 'react'
import styled from 'styled-components' 
import { useSelector, useDispatch } from 'react-redux' 
import ModalCloseButton from 'components/buttons/ModalCloseButton'
import SpinnerSmall from 'components/SpinnerSmall' 
import { pBtn, pBtnSmall } from 'components/main.styled' 
import { toast } from 'react-hot-toast'
import { StyledHeading, UploadModalContainer } from 'components/media/media.styled';
import { BsFillImageFill } from "react-icons/bs";
import { setImagesToUpload, uploadImages, setViewImageUploadModal } from 'features/images/imagesSlice'
import ImageToUploadItem from './ImageToUploadItem' 
import { useTranslation } from 'react-i18next'

export default function ImageUploadModal() {
    const { t } = useTranslation('media')
    
    const dispatch = useDispatch()
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { imagesToUpload, uploadImagesStatus } = useSelector((state) => state.images)

    const handleSubmit = () => {

        if(imagesToUpload.length === 0){
            return toast.error(t('validation.selectImages'))
        }

        let formData = new FormData()
        imagesToUpload.forEach((image) => {
            formData.append('files', image.fileSrc);
        });
        formData.append('churchId', profileChurch._id)

        dispatch(uploadImages(formData));

    }       

    useEffect(() => {

    }, [])

    const handleAddImages = (e) => {
        const files = Array.from(e.target.files || []);

        if (files.length === 0) return;

        const validExtensions = ['jpeg', 'jpg', 'png'];
        const images = [];

        for (let file of files) {
            const ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();

            if (!validExtensions.includes(ext)) {
                toast.error(t('validation.invalidImage', { name: file.name }));
                continue;
            }

            images.push({
                src: URL.createObjectURL(file),
                alt: file.name,
                fileSrc: file,
            });
        }

        if(images.length > 10){
            toast.error(t('validation.maxImages'))
            images.splice(10);
            return;
        }

        if (images.length === 0) return;
 
        dispatch(setImagesToUpload(images));

    }

    const handleCancel = () => {
        dispatch(setImagesToUpload([]));
    }

    return (
        <UploadModalContainer>
            <ModalCloseButton
                handler={() => dispatch(setViewImageUploadModal(false))}
                size='30px'
                top='10px'
                right='10px' 
                />

            <StyledHeading> <BsFillImageFill size={24} /> <span>{t('imageUpload')}</span> </StyledHeading>

            <div style={{  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', height: '100%', width: '100%'}}> 
                <ImagesSelected>
                    {
                        imagesToUpload.length === 0 ?
                        (
                            <div>
                                {t('noImagesSelected')}
                            </div>
                        )
                        :
                        (
                            <ImagesToUploadContainer>
                                {imagesToUpload.map((image, index) => (
                                    <ImageToUploadItem 
                                        key={index}
                                        alt={image.alt}
                                        src={image.src}
                                        isLoading={uploadImagesStatus === "LOADING"} 
                                        /> 
                                ))}
                            </ImagesToUploadContainer>
                        )
                    }
                </ImagesSelected>
                <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                    <CancelBtn onClick={handleCancel}>
                        {t('cancel')}
                    </CancelBtn>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleAddImages}
                        multiple
                        style={{ marginTop: '20px' }}
                        hidden
                        id='select-image'
                    />
                    <SelectBtnWrap>
                        <div style={{ fontSize: "12px", color: "#cccccc"}}>{t('selectLimit')}</div>

                        {
                            imagesToUpload.length > 0 ?
                            (
                                <UploadImagesButton
                                    onClick={handleSubmit}
                                    >
                                    {
                                        uploadImagesStatus === "LOADING" ?
                                        (
                                            <SpinnerSmall />
                                        )
                                        :
                                        (
                                            t('uploadImages')
                                        )
                                    }
                                </UploadImagesButton>
                            )
                            :
                            (
                                <SelectImgBtn
                                    htmlFor='select-image'
                                    >
                            
                                    {t('selectImages')}
                                </SelectImgBtn>
                            )
                        }                        
                    </SelectBtnWrap>
              
                </div>      
            </div> 
        </UploadModalContainer>
    )
}

const SelectBtnWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
`

const UploadImagesButton = styled(pBtn)`
    background-color: var(--themeColor);
    color: white; 
`

const CancelBtn = styled(pBtn)`
    background-color: grey;
    color: #e1e1e1;
    margin-right: 10px;
`

const ImagesToUploadContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: scroll;



`

const ImagesSelected = styled.div`
    width: 100%;
    height: 250px;
    border: 2px dashed #cbcbcb;
    border-radius: 10px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--lightThemeFontColor);
    font-size: 14px;
    text-align: center; 
    padding: 20px;
`

const SelectImgBtn = styled.label` 
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    height: 40px;
    border-radius: 25px;
    background-color: var(--themeColor);
    color: white;
    border: none; 
    cursor: pointer;
    font-size: 13px;
    transition: all 0.3s ease-in-out;

    &:hover{
        background-color: var(--themeColor);
    }

`
